export const ImageTypes: ReadonlySet<string> = new Set([
  'image/jpeg',
  'image/gif',
  'image/bmp',
  'image/png',
  'image/tiff',
  'image/webp',
]);

export const VideoTypes: ReadonlySet<string> = new Set([
  'video/mp4',
  'video/ogg',
  'video/x-msvideo',
  'video/quicktime',
  // this is an unofficial mime type, but it's used by chrome so we need to support it
  'video/avi',
]);

export const AudioTypes: ReadonlySet<string> = new Set([
  'audio/wav',
  'audio/x-wav',
  'audio/mp3',
  'audio/mp4',
  'audio/mpeg',
  'audio/x-m4a',
]);

export const SlideDeckTypes: ReadonlySet<string> = new Set([
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
]);

// We need to handle office documents differently for CloudConvert
// TODO: Restructure officeDocumentTypes and slideDeckTypes differently once
// the slide-deck feature is enabled for everyone.
export const OfficeDocumentTypes: ReadonlySet<string> = new Set([
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  // Some excel files don't convert properly in cloud-convert, possibly resulting in an uploads-converter pod having to restart
  // For now we decided to simply disable it
  // A product decision needs to be made to consider whether we should invest time to fix it
  // 'application/vnd.ms-excel',
  // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  ...SlideDeckTypes,
]);

export const DocumentTypes: ReadonlySet<string> = new Set(['application/pdf', ...OfficeDocumentTypes]);
